import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { RouteReferrerState, routes } from '../../../routes/routesConfig';
import { gtag } from '../../../utils/gtag';
import { WizardStepsRouteConfig } from './types';

export const useWizardNavigateToNextStepCallback = <
  StepId extends Readonly<string>
>(
  steps: WizardStepsRouteConfig<StepId>
) => {
  const history = useHistory<RouteReferrerState>();
  const isStepId = useCallback(
    (stepId: Readonly<string>): stepId is StepId => stepId in steps,
    [steps]
  );

  return useCallback(
    (nextStepId: Readonly<string> | StepId | null) => {
      const { state } = history.location;

      if (nextStepId === null || !isStepId(nextStepId)) {
        gtag('event', 'wizard-completed');
        history.push(state?.referrer ?? routes.home.path);
        return;
      }

      const nextStep = steps[nextStepId];

      gtag('event', 'wizard-step-completed', {
        nextStepId,
      });
      history.push(nextStep.routeConfig.path, state);
    },
    [history, steps, isStepId]
  );
};

export const useWizardCloseCallback = () => {
  const history = useHistory<RouteReferrerState>();
  return useCallback(() => {
    const { state } = history.location;
    history.push(state?.referrer ?? routes.home.path);
  }, [history]);
};
